import { Injectable, inject } from "@angular/core";
import { LG_APP_CONFIGURATION, ServerGatewayBase } from "@logex/framework/lg-application";
import { Observable } from "rxjs";

export interface Client {
    id: number;
    code: string;
    name: string;
    abbreviation: string;
}

@Injectable({ providedIn: "root" })
export class BootHelperGateway extends ServerGatewayBase {
    constructor() {
        super();
        const appConfig = inject(LG_APP_CONFIGURATION);
        this._setBaseUrl(appConfig.applicationRoot);
    }

    selectClients(): Observable<Client[]> {
        return this._postQuery<Client[]>("boot/clients");
    }
}
